var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import * as RenderMethods from "./RenderMethods";
import { observer } from "mobx-react";
import { getCountLinkParams, getCardDetailsParams } from "../../../../helpers";
var EventCard = /** @class */ (function (_super) {
    __extends(EventCard, _super);
    function EventCard(props) {
        var _this = _super.call(this, props) || this;
        _this.renderEventCardDetails = RenderMethods.renderEventCardDetails;
        _this.renderMarkets = RenderMethods.renderMarkets;
        _this.renderMarketsCountLink = RenderMethods.renderMarketsCountLink;
        _this.getCountLinkParams = getCountLinkParams;
        _this.getCardDetailsParams = getCardDetailsParams;
        _this.cardTypeClass = "";
        _this.buttonsHolderClass = "";
        _this.componentPrefix = "ev-card";
        return _this;
    }
    EventCard.prototype.setClasses = function () {
        var liveClass = this.props.event.isLive
            ? "rj-ev-list__" + this.componentPrefix + "--live"
            : "rj-ev-list__" + this.componentPrefix + "--upcoming";
        var classNames = this.props.classNames || "";
        var isSuspended = this.props.event.isSuspended
            ? "rj-ev-list__" + this.componentPrefix + "--suspended"
            : "";
        var hideGameState = this.props.hideGameState
            ? "rj-ev-list__" + this.componentPrefix + "--game-state-hidden"
            : "";
        return "rj-ev-list__" + this.componentPrefix + " " + liveClass + " " + this.cardTypeClass + " " + classNames + " " + isSuspended + " " + hideGameState;
    };
    EventCard.prototype.render = function () {
        return (React.createElement("div", { className: this.setClasses(), "data-uat": "div-ev-list-" + this.componentPrefix },
            React.createElement("div", { className: "rj-ev-list__" + this.componentPrefix + "__inner", "data-uat": "div-ev-list-" + this.componentPrefix + "-inner" },
                this.renderEventCardDetails(this.getCardDetailsParams(this.props), this.componentPrefix),
                this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix),
                this.renderMarketsCountLink(this.getCountLinkParams(this.props), this.componentPrefix))));
    };
    EventCard = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], EventCard);
    return EventCard;
}(React.Component));
export { EventCard };
//# sourceMappingURL=EventCard.js.map